const BuildObserverUtil = function (tagnames, types) {
	var _private = {
		tagnames: tagnames,

		types: types,

		listeners: {
			nodes: new Map(),
			classes: new Map(),
			removes: new Map()
		},

		isListeningTarget: function (target) {
			if (!_private.tagnames) {
				return true;
			}

			return _private.tagnames.indexOf(target.tagName) !== -1;
		},

		isListeningMutationType: function (type) {
			if (!_private.types) {
				return true;
			}

			return _private.types.indexOf(type) !== -1;
		},

		isListeningMutation: function (mutation) {
			return this.isListeningMutationType(mutation.type) && this.isListeningTarget(mutation.target);
		},

		callObserver: function (classname, callback, node) {
			callback($(node));
		},

		compareNodeClassname: function (node, classname, override_classname) {
			var result = false;

			if (node.classList) {
				result = node.classList.contains(classname);
			} else {
				result = $(node).hasClass(classname);
			}

			if (!result && override_classname) {
				result = new RegExp("\\b" + classname + "\\b").test(override_classname);
			}

			return result;
		},

		callNodeMutationOnChilds: function (node, listeners, override_classname) {
			var self = this;

			var childs = node.childNodes;
			if (childs && childs.length) {
				var childsArray = Array.prototype.slice.call(childs);
				childsArray.forEach(function (child_node) {
					self.handleNodeMutation(child_node, listeners, true, override_classname);
				});
			}
		},

		handleNodeMutation: function (node, listeners, with_childs, override_classname) {
			var self = this;

			if (!with_childs) {
				with_childs = false;
			}

			if (with_childs) {
				this.callNodeMutationOnChilds(node, listeners, override_classname);
			}

			listeners.forEach(function (callback, classname) {
				var is_current_node = self.compareNodeClassname(node, classname, override_classname);

				if (is_current_node) {
					_private.callObserver(classname, callback, node);
				}
			});
		},

		handleMutation: function (mutation) {
			if (!_private.isListeningMutation(mutation)) {
				return;
			}

			if (mutation.type === 'childList') {
				var listeners = _private.listeners.nodes;

				for (let i = 0; i < mutation.addedNodes.length; i++) {
					var node = mutation.addedNodes[i];
					if (node.nodeType === 1) {
						_private.handleNodeMutation(node, listeners, true);
					}
				}

				if (mutation.target) {
					_private.handleNodeMutation(mutation.target, listeners);
				}

				var removes_listeners = _private.listeners.removes;

				for (let i = 0; i < mutation.removedNodes.length; i++) {
					var node = mutation.removedNodes[i];
					if (node.nodeType === 1) {
						_private.handleNodeMutation(node, removes_listeners, true);
					}
				}
			} else if (mutation.type === 'attributes') {
				if (mutation.attributeName === 'class') {
					var listeners = _private.listeners.classes;

					_private.handleNodeMutation(mutation.target, listeners, false, mutation.oldValue);
				}
			}
		},

		handleMutations: function (mutations) {
			mutations.forEach(_private.handleMutation);
		}
	};

	return {
		inited: false,

		init: function() {
			var observer = new MutationObserver(_private.handleMutations);

			observer.observe(document, {
				subtree: true,
				childList: true,
				attributes: true,
				attributeOldValue: true
			});

			this.inited = true;
		},

		watchTag: function (tagname) {
			if (_private.tagnames.indexOf(tagname) !== -1) {
				return;
			}

			_private.tagnames.push(tagname);
		},

		watchType: function (type) {
			if (_private.types.indexOf(type) !== -1) {
				return;
			}

			_private.types.push(type);
		},

		observe: function (class_name, callback) {
			if (!this.inited) {
				this.init();
			}

			_private.listeners.nodes.set(class_name, callback);
		},

		observeRemove: function (class_name, callback) {
			if (!this.inited) {
				this.init();
			}

			_private.listeners.removes.set(class_name, callback);
		},

		observeClass: function (class_name, callback) {
			if (!this.inited) {
				this.init();
			}

			this.watchType('attributes');
			_private.listeners.classes.set(class_name, callback);
		},

		observeComponent: function (class_name, component) {
			this.observe(class_name, function ($node) {
				component($node);
			});
		},
	};
};

const ObserverUtil = BuildObserverUtil(['DIV', 'SPAN', 'A', 'BODY', 'INPUT', 'TEXTAREA', 'YMAPS', 'JDIV'], ['childList']);

export default ObserverUtil;
